package ui.license.detail.components

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Calendar
import compose.assets.svg.Device
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import ssoft.frontend.generated.resources.*
import tools.formatFromRes
import tools.rememberString
import ui.license.detail.LicenseDetailScope
import ui.license.detail.LicenseDetailScope.Wrapper.CreatorItem
import ui.license.detail.LicenseDetailVM
import ui.widget.Dialog
import ui.widget.DialogState
import ui.widget.DialogUI
import kotlin.time.Duration.Companion.days
import kotlin.time.Instant

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun DatePicker(entry: CreatorItem, dialogPickerState: DialogState) {
    Dialog(dialogPickerState) {
        val dateState = rememberDatePickerState(
            initialSelectedDateMillis = entry.startField.state.toEpochDays().days.inWholeMilliseconds
        )
        DatePickerDialog(
            onDismissRequest = {
                dialogPickerState.hide()
            },
            dismissButton = {
                TextButton({ dialogPickerState.hide() }) {
                    Text(Res.string.dialog__action_cancel.rememberString())
                }
            },
            confirmButton = {
                TextButton({
                    dateState.selectedDateMillis?.also {
                        entry.startField.set(
                            Instant.fromEpochMilliseconds(it)
                                .toLocalDateTime(TimeZone.currentSystemDefault()).date
                        )
                    }
                    dialogPickerState.hide()
                }) {
                    Text(Res.string.dialog__action_ok.rememberString())
                }
            }
        ) {
            DatePicker(dateState)
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun LicenseDetailScope.LicenseUploadDialog(uploaderState: DialogState) {
    Dialog(uploaderState) {
        val entry = remember {
            CreatorItem()
        }
        val datePickerState = DialogState.remember(key = "date-picker")

        DatePicker(entry, datePickerState)
        DialogUI(
            modifier = Modifier.align(Alignment.Center),
            onDismissRequest = { uploaderState.hide() },
            title = { Text(Res.string.license_detail_license_add.rememberString()) },
            dismissButton = {
                TextButton({
                    uploaderState.hide()
                }) { Text(Res.string.dialog__action_cancel.rememberString()) }
            },
            confirmButton = {
                TextButton(
                    enabled = !entry.priceField.err,
                    onClick = {
                        action(LicenseDetailVM.Action.Upload(entry))
                        uploaderState.hide()
                    }) {
                    Text(Res.string.license_detail_license_add_upload.rememberString())
                }
            }
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                TextField(
                    shape = RoundedCornerShape(topStart = 12.dp, topEnd = 12.dp),
                    value = entry.priceField.text,
                    label = { Text(Res.string.license_detail_license_add_price.rememberString()) },
                    leadingIcon = { Icon(Svg.Device, null) },
                    isError = entry.priceField.err,
                    modifier = Modifier.fillMaxWidth(),
                    onValueChange = { entry.priceField.set(it) })
                Card(
                    onClick = { datePickerState.show() },
                    shape = RoundedCornerShape(topStart = 12.dp, topEnd = 12.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(
                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 8.dp),
                        horizontalArrangement = Arrangement.spacedBy(14.dp)
                    ) {
                        Icon(
                            imageVector = Svg.Calendar,
                            contentDescription = null,
                            modifier = Modifier.align(Alignment.CenterVertically)
                        )
                        Column {
                            Text(
                                text = Res.string.license_detail_license_add_date.rememberString(),
                                style = MaterialTheme.typography.labelSmall
                            )
                            Text(
                                text = entry.startField.state.formatFromRes(),
                                style = MaterialTheme.typography.bodyMedium
                            )
                        }
                    }
                }
            }
        }
    }
}
